export class NWSRegionRoutes
{
    static Home: string = "/";
    // region
    static RegionList: string = "/region/list";
    static RegionView(id: string)
    {
        return `/region/${id}/view`;
    }
}